import { useMemo } from 'react';

// Create a context for all .js files in the posts directory
const blogContext = require.context('../blog/posts', false, /\.js$/);

// Required fields for a valid blog post
const REQUIRED_FIELDS = ['title', 'date', 'content'];

// Load and validate all blog posts
const loadBlogPosts = () => {
  return blogContext.keys()
    .map(key => {
      const post = blogContext(key);
      const slug = post.slug || key.replace(/^\.\/(.*)\.js$/, '$1');
      
      // Skip posts missing required fields
      if (REQUIRED_FIELDS.some(field => !post[field])) {
        console.warn(`Skipping post "${slug}" - missing required fields`);
        return null;
      }
      
      return {
        slug,
        title: post.title,
        date: post.date,
        excerpt: post.excerpt,
        author: post.author,
        category: post.category,
        content: post.content,
      };
    })
    .filter(Boolean) // Remove null entries
    .sort((a, b) => new Date(b.date) - new Date(a.date));
};

// Cache the loaded posts
const allPosts = loadBlogPosts();

// Hook to get all blog posts
export function useBlogPosts() {
  return useMemo(() => allPosts, []);
}

// Hook to get a single blog post by slug
export function useBlogPost(slug) {
  return useMemo(() => {
    const post = allPosts.find(post => post.slug === slug);
    
    if (!post) {
      return {
        title: 'Post Not Found',
        date: new Date().toISOString(),
        author: 'Unknown',
        excerpt: 'The requested blog post could not be found.',
        content: 'This post does not exist or has been removed.',
      };
    }
    
    return post;
  }, [slug]);
} 